export const PALETTE = ["#6366f1", "#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4", "#ec4899", "#14b8a6", "#f97316"];

export const SIMPLE_PALETTE = ["#3b82f6"];

export const KPI_COLORS = ["#3b82f6", "#10b981", "#8b5cf6", "#f59e0b", "#06b6d4", "#ef4444"];

export const tooltipStyle: React.CSSProperties = {
	background: "#fff",
	border: "none",
	borderRadius: 12,
	boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
	padding: "10px 14px",
	fontSize: 13,
};
